module.exports = __webpack_public_path__ + "img/20210830_173904.8791de53.jpg";